export enum TypeEventCodeEnum {
  LIGUE = 'LIGUE',
  LIG_BR = 'LIG_BR',
  TOURNAMENT = 'TOURNAMENT',
  TOURNAMENT_DOUBLE_ELEM = 'TOURNAMENT_DOUBLE_ELEM',
}
